function getProfilingRequiredDialogMainDescription({
	numFilesOriginallySelectedByUser,
	numFilesRequiringProfiling,
}) {
	if (
		numFilesOriginallySelectedByUser === 1 &&
		numFilesRequiringProfiling === 0
	) {
		return `The document you're uploading does not require profiling before upload.`;
	} else if (
		numFilesOriginallySelectedByUser === 1 &&
		numFilesRequiringProfiling === 1
	) {
		return `The document you're uploading requires profiling before upload. Please populate the indicated fields below.`;
	} else if (numFilesRequiringProfiling === 1) {
		return `You're uploading ${numFilesOriginallySelectedByUser} documents, 1 of which requires profiling before upload. Please populate the indicated fields below.`;
	} else if (
		numFilesRequiringProfiling === numFilesOriginallySelectedByUser
	) {
		return `You're uploading ${numFilesOriginallySelectedByUser} documents, all of which require profiling before upload. Please populate the indicated fields below.`;
	} else if (numFilesRequiringProfiling > 0) {
		return `You're uploading ${numFilesOriginallySelectedByUser} documents, ${numFilesRequiringProfiling} of which require profiling before upload. Please populate the indicated fields below.`;
	} else {
		// A firm can enable "prompt for profiling", but not have any required fields.
		// Profiling is optional for the uploading user
		return `You're uploading ${numFilesOriginallySelectedByUser} documents, none of which require profiling before upload.`;
	}
}

export { getProfilingRequiredDialogMainDescription };
